import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import AuthorFollowButton from "../../author/author_follow_button";
import AuthorFollowCount from "../../author/author_follow_count";
import AuthorBadge from "../../author/author_badge";

export default GrComponentFactory.createClass({
  displayName: "AuthorFollowDetails",

  propTypes: {
    user: GrPropTypes.user(),
    author: GrPropTypes.author().isRequired,
    userAuthorFollowingsUrl: React.PropTypes.string,
  },

  renderAuthorName() {
    const author = this.props.author;
    return (
      <div className="gr-newsfeedItem__authorFollowTitle">
        <a href={author.profileUrl} className="gr-newsfeedItem__resourceNameLink">
          {author.name}
        </a>
        <AuthorBadge {...author} />
      </div>
    );
  },

  render() {
    const authorId = this.props.author.id;

    return (
      <div className="gr-newsfeedItem__details">
        {this.renderAuthorName()}
        <AuthorFollowCount authorId={authorId} className="gr-newsfeedItem__ratingDetailsText u-defaultType" />
        <AuthorFollowButton authorId={authorId} className="u-marginTopMedium" />
      </div>
    );
  },
});
